module.exports = __webpack_public_path__ + "static/media/ChannelSong.English.d251297a.jpg";